export const SMS_PROGRAM_NAME = 'Pop-Up Yoga Account Alerts';

export const SMS_CONSENT_TEXT =
  `I agree to receive transactional text messages from Pop-Up Yoga (${SMS_PROGRAM_NAME}) — ` +
  'verification codes, class registration confirmations, cancellation notices, and waitlist updates. ' +
  'Message frequency varies. Msg & data rates may apply. Reply STOP to opt out at any time, HELP for help.';
